import { createAction } from '@reduxjs/toolkit';

import { UIState } from '../../types.ts';

export const resolveFeatureGridFieldConflicts = createAction<
  UIState['featureGridConflictedFields']
>('resolveFeatureGridFieldConflicts');
